class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    if(this.currentVariant){
      let optionIndex = parseInt(document.querySelector('.selected-variant').getAttribute('data-option-index'));
      this.currentVariant.options.forEach((value,index) => {
        if(index == optionIndex){
          document.querySelectorAll('.selected-variant').forEach((selectedVal) => {
            selectedVal.textContent = value;
          })
        }
      })
    }
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
      // if(document.querySelector('.choose-cart')) document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      // if(document.querySelector('.choose-selector')) document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
      // if(document.querySelector('.choose-cart')) document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      // if(document.querySelector('.choose-selector')) document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.p-add-cart-btn');
    if(this.currentVariant != undefined){
      if(this.currentVariant.available){
        if(productForm.querySelector(".choose-cart")) productForm.querySelector(".choose-cart").classList.remove('variant_sold-out');
      }else{
        if(productForm.querySelector(".choose-cart")) productForm.querySelector(".choose-cart").classList.add('variant_sold-out'); 
      }
    }
  
    if(!addButton) return;
    // if(disable){
    //   if(addButtonText) addButton.setAttribute('disabled', 'disabled');
    //   if(text && addButtonText) addButtonText.textContent = text;
    // }else{
    //   if(addButtonText) addButton.removeAttribute('disabled');
    //   if(addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
    // }
    if(!modifyClass) return;
  }
  setUnavailable(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span.p-add-cart-btn');
    const price = document.getElementById(`price-${this.dataset.section}`);
    // if (!addButton) return;
    // addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData(){
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if(document.querySelectorAll('.product-addcart')){
  document.querySelectorAll('.product-addcart').forEach(function(addToCart){
    addToCart.addEventListener('click',function(evt){
      evt.preventDefault();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var cartform = document.querySelector('.product-addcart').closest('form');
      const formData = new FormData(cartform);  
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(function(e){
            document.querySelector('.product-form-error').innerHTML  = '';
          },2000);
          return;
        }else{
          if(typeof load_cart == 'function'){
            cartNotification(response.id);
            load_cart();
            if(window.innerWidth >= 991){
              setTimeout(function(e){
                document.querySelector('body').classList.add('open-drawer');
              },500);
            }
          }else{
            window.location.href = "/cart";
          }
        }
        evt.target.closest('form').querySelector('.added-cart').style.display = 'flex';
        evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'none';
        setTimeout(function(e){
          evt.target.closest('form').querySelector('.added-cart').style.display = 'none';
          evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'flex';
        },2000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
    });
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 991) {
    if (!init) {
      init = true;
      swiper = new Swiper(".media-grid.swiper", {
        direction: "horizontal",
        slidesPerView: "auto",
        centeredSlides: true,
        navigation: {
          nextEl: ".prod-arrows.swiper-button-next",
          prevEl: ".prod-arrows.swiper-button-prev",
        },
        pagination: {
          el: ".product-wrap .swiper-pagination",
          clickable: true,
          hide: true,
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration){
  var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if(!diff) return
	window.requestAnimationFrame(function step(timestamp){
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if(window.innerWidth < 992) {
    document.querySelectorAll('.choose-selector a').forEach(function(selectBtn){
      selectBtn.addEventListener('click', doScrolling.bind(null, '#product-form-installment', 1000))
    });
  }
}
if(document.querySelector('.color-remian')) document.querySelector('.color-remian').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelectorAll('.grid-meta-color li.hide_colors').forEach((hideColor) => {
    document.querySelector('.color-remian').style.display = 'none';
    hideColor.classList.remove('hide_colors');
  })
})
if(document.querySelector('.mb-color-remian')) document.querySelector('.mb-color-remian').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelectorAll('.grid-meta-color li.mb_hide_colors').forEach((hideColor) => {
    document.querySelector('.mb-color-remian').style.display = 'none';
    hideColor.classList.remove('mb_hide_colors');
  })
})
document.querySelectorAll('.meta-color .grid-meta-color li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(window.innerWidth > 991 && color.querySelector('a') != null && document.querySelector('.meta-color-title') != null){
      if(document.querySelector('.meta-color-title span')) document.querySelector('.meta-color-title span').textContent = color.querySelector('a').getAttribute('data-val');
    }
  })
  color.addEventListener('mouseout',function(){
    if(window.innerWidth > 991 && color.querySelector('a') != null && document.querySelector('.meta-color-title') != null){
      if(document.querySelector('.meta-color-title span')) document.querySelector('.meta-color-title span').textContent = document.querySelector('.meta-color a').getAttribute('data-val');
    }
  })
})
let getReview = setInterval(myReview,100);
function myReview(a, b){
  if(document.querySelector('div#shopify-block-okendo_star_rating_Bb8KGx')) document.querySelector('div#shopify-block-okendo_star_rating_Bb8KGx').addEventListener('click', function(e){
    e.preventDefault();
    clearTimeout(getReview);
    document.querySelector('.accordian-wrap[data-title="review"]').classList.add('active');
    document.querySelector('.accordian-content[data-title="review"]').classList.add('active');
  })
}
function accordian(){
  const accordions = document.querySelectorAll(".accordian-wrap");
  const openAccordion = (accordion) => {
    let title = accordion.getAttribute('data-title');
    document.querySelectorAll(".accordian-content").forEach((accoContent) => {
      let titles = accoContent.getAttribute('data-title');
      if(titles == title){
        accoContent.classList.add("active");
      }
    })
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
  };
  const closeAccordion = (accordion) => {
    let title = accordion.getAttribute('data-title');
    document.querySelectorAll(".accordian-content").forEach((accoContent) => {
      let titles = accoContent.getAttribute('data-title');
      if(titles == title){
        accoContent.classList.remove("active");
      }
    })
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
  };
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    intro.onclick = () => {
      accordions.forEach((accordion) => closeAccordion(accordion));
      openAccordion(accordion);
    };
  });
}
accordian();
document.addEventListener("shopify:section:load", function(event) {
  accordian();
});
document.querySelectorAll('.acco-close').forEach(function(accoClose){
  accoClose.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector(".accordian-content.active").classList.remove("active");
    document.querySelector(".accordian-wrap.active").classList.remove("active");
  });
});
window.addEventListener('scroll', function() {
  var div = document.querySelector('.snippet-addto-cart');
  var body = document.body;
  var rect = div.getBoundingClientRect();
  var topOffset = rect.top;
  if (topOffset <= 0) {
    document.querySelector('body').classList.add('stickybar');
    var sectionFooter = document.querySelector('.section-footer');
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
    var Buttons = document.querySelectorAll('.snippet-sticky-product-cart');
    Buttons.forEach(function(button) {
      if(section < 0){
        button.style.display = 'none';
      } else {
        button.style.display = 'block';
      }
    });
  } else {
    document.querySelector('body').classList.remove('stickybar');
  }
});
if(document.querySelector('.model_switch')) document.querySelectorAll('.model_switch a').forEach((switcher) => {
  switcher.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelectorAll('.model_switch a').forEach((switchModel) => {
      switchModel.closest('li').classList.remove('active');
    });
    switcher.closest('li').classList.add('active');
    switcher.closest('.product-media').querySelector('.media-grid').setAttribute('data-val',switcher.closest('li').getAttribute('data-val'));
  });
})
function switchActiveChild(){
  let announce = document.querySelector('.order-shipped');
  let announceText = announce.querySelectorAll('p');
  let currentActive = announce.querySelector('.active');
  let currentIndex = Array.from(announceText).indexOf(currentActive);
  let nextIndex = (currentIndex + 1) % announceText.length;
  let announceAllActive = document.querySelectorAll(".order-shipped p.active");
  announceAllActive.forEach((announceActive) => {
    announceActive.classList.remove("active");
  });
  announceText[nextIndex].classList.add('active');
}
setInterval(switchActiveChild, 2000);